import React, {Component} from "react"

export default class Icon extends Component {
  render() {
    return <i className={"sh-icon fa fa-" + this.props.i} />
  }
}



// WEBPACK FOOTER //
// ./src/components/decorators/Icon.js